import React from "react";

function NetworkIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 320.531 320.531"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M149.435,119.164V63.57c13.007-3.342,22.648-15.168,22.648-29.204c0-16.624-13.524-30.148-30.148-30.148
		c-16.623,0-30.147,13.524-30.147,30.148c0,14.036,9.641,25.861,22.647,29.203v55.594c-15.775,2.374-29.169,12.115-36.556,25.597
		l-32.99-25.646c0.807-2.271,1.25-4.714,1.25-7.258c0-11.99-9.755-21.745-21.745-21.745s-21.745,9.755-21.745,21.745
		s9.755,21.745,21.745,21.745c3.972,0,7.695-1.076,10.903-2.943l37.29,28.989c-0.55,2.971-0.852,6.027-0.852,9.155
		c0,11.14,3.652,21.44,9.815,29.777l-42.163,42.163c-2.929,2.929-2.929,7.678,0,10.606c1.465,1.464,3.385,2.197,5.304,2.197
		s3.839-0.732,5.304-2.197l42.163-42.163c6.429,4.753,14.026,8.012,22.277,9.254v55.718c-8.306,3.062-14.245,11.056-14.245,20.411
		c0,11.99,9.755,21.745,21.745,21.745s21.745-9.755,21.745-21.745c0-9.356-5.939-17.35-14.245-20.411v-55.717
		c24.136-3.631,42.7-24.506,42.7-49.637C192.135,143.67,173.57,122.795,149.435,119.164z M44.394,118.602
		c-3.72,0-6.745-3.026-6.745-6.745s3.025-6.745,6.745-6.745s6.745,3.026,6.745,6.745S48.113,118.602,44.394,118.602z
		 M126.787,34.366c0-8.353,6.795-15.148,15.147-15.148s15.148,6.795,15.148,15.148c0,8.353-6.796,15.148-15.148,15.148
		S126.787,42.719,126.787,34.366z M141.935,301.313c-3.72,0-6.745-3.026-6.745-6.745c0-3.255,2.317-5.979,5.389-6.608
		c0.44,0.081,0.892,0.129,1.356,0.129s0.916-0.048,1.356-0.129c3.072,0.629,5.389,3.353,5.389,6.608
		C148.68,298.287,145.654,301.313,141.935,301.313z M141.935,204.001c-19.409,0-35.199-15.791-35.199-35.2
		c0-3.425,0.501-6.734,1.417-9.867c0.049-0.155,0.095-0.309,0.133-0.466c4.425-14.382,17.834-24.867,33.649-24.867
		c19.409,0,35.2,15.791,35.2,35.2C177.135,188.211,161.344,204.001,141.935,204.001z"
        />
        <path
          d="M290.384,95.953c-16.624,0-30.148,13.524-30.148,30.148c0,0.775,0.039,1.54,0.097,2.3l-54.238,18.493
		c-3.921,1.336-6.016,5.599-4.679,9.519c1.063,3.119,3.977,5.082,7.098,5.082c0.803,0,1.619-0.13,2.421-0.403l54.236-18.492
		c5.392,8.212,14.677,13.65,25.214,13.65c16.623,0,30.147-13.524,30.147-30.148C320.531,109.478,307.007,95.953,290.384,95.953z
		 M290.384,141.25c-8.353,0-15.148-6.795-15.148-15.148c0-8.353,6.796-15.148,15.148-15.148s15.147,6.795,15.147,15.148
		C305.531,134.454,298.736,141.25,290.384,141.25z"
        />
        <path
          d="M30.148,250.44C13.524,250.44,0,263.965,0,280.588c0,16.624,13.524,30.148,30.148,30.148
		c16.623,0,30.147-13.524,30.147-30.148C60.296,263.965,46.771,250.44,30.148,250.44z M30.148,295.737
		c-8.353,0-15.148-6.795-15.148-15.148c0-8.353,6.796-15.148,15.148-15.148s15.147,6.795,15.147,15.148
		C45.296,288.941,38.501,295.737,30.148,295.737z"
        />
      </g>
    </svg>
  );
}

export default NetworkIcon;
